/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    exports.extractNumber = function (val) {
        var number = val.replace(/\D/g, '');
        return number;
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/extractNumber.js
// module id = 39
// module chunks = 0